import React from "react";
import classnames from 'classnames'
import { ReadPropsUserHaveAsset, ReadPropsUserAsset } from "../request.props.js";
import { PresenterReadUserHaveAsset, PresenterReadUserAsset } from "../../presenter.js";
import UserRow from "./UserRow.js";
import {HandlingSometingWentWrong} from '../../../../utils/HandlingMessage.js'
import TimerConfig from '../../../../utils/TimerConfig.js';
import ModalUserDetail from './Modal/ModalUserDetail.js'
import FilterComponent from '../../../../asset/simple_asset/helper/component/FilterComponent.js';
import Pagination from '../../../../component/Pagination.js'
import iconMaping from '../../../../utils/IconMaping.js';

// TOAST
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import windowStop from "../../../../utils/windowStop.js";

export default class UserList extends React.Component {
  constructor() {
    super();
    this.state = {
      assetElement      : [],
      RowElement        : "",
      selectedData      : null,
      NextPage          : null,
      isLoading         : true,
      loadingLoadMore   : true,
      isSometingWrong   : false,
      detailModal       : false,
      // user              : false,
      // city              : false,
      // role              : false,
      // email             : false,
      activeToggle      : {activeIcon : null, activeField : 'User__first_name'},
      // ***Pagination
      table_loading : false,
      current       : 0,
      count         : 0,
      limit         : 0,
      fieldSort:{
        asc   : true,
        field :''
      },
    };

    //* Default Param Filter & Order */
    this.params_filter = ''
    this.params_order  = 'ordering=User__first_name'
    this.params_page   = 1

    this.tab = ['user', 'email', 'role', 'city']

    this.assetData                = [];
    this.userData                 = [];

    this.generateRow              = this.generateRow.bind(this);
    this.closeModalUserDetail     = this.closeModalUserDetail.bind(this)
    this.toggleModalUserDetail    = this.toggleModalUserDetail.bind(this)
    this.onReadSuccess						= this.onReadSuccess.bind(this);
    this.onReadFailed 						= this.onReadFailed.bind(this);
    this.onReadAssetSuccess 			= this.onReadAssetSuccess.bind(this);
  }
  
  onSearchHandler(e) {
    if (e.key === "Enter") {
    	this.params_page = 1
      this.loadData(this.params_filter, this.params_order, this.params_page);
    }
  }

  toggleModalUserDetail(selectedData){
    this.setState({ 
      selectedData  : selectedData,
      detailModal   : true,
    })  
    PresenterReadUserAsset(
      ReadPropsUserAsset("read", this ,this.onReadAssetSuccess,this.onReadFailed, selectedData)
    )
  }

  closeModalUserDetail(){
    this.setState({ 
      detailModal   : false,
      selectedData  : null,
      assetElement  : null, 
    })
    windowStop()
  }

  paginationHandler(props){
    PresenterReadUserHaveAsset(props)
  }

  dataWillOrder(order){
    let parameter_order = 'ordering=' + order;
    this.setState({activeToggle: {
      activeField : order,
      activeIcon  : iconMaping.AVICON_ASC   
    }})

    if(this.params_order === parameter_order){
      this.params_order = 'ordering=-' + order;
      this.setState({activeToggle: {
        activeField : order,
        activeIcon  : iconMaping.AVICON_DESC 
      }})

    } else {
      this.params_order = parameter_order;
      this.setState({activeToggle: {
        activeField : order,
        activeIcon  : iconMaping.AVICON_ASC
      }})
    }
    this.loadData(this.params_filter, this.params_order, this.params_page);
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <UserRow 
          RowData={val}
          key={val.Alias}
          toggleModalUserDetail={this.toggleModalUserDetail}
          UserReducer={this.props.UserReducer}
        />
      );
    });
    return element;
  }

  handlePageClick(data) {
    windowStop()
    let selected = data.selected + 1;
    this.params_page = selected
    this.setState({ table_loading: true})
    this.loadData(this.params_filter, this.params_order, this.params_page);
  };

  dataWillFilter(filter){
    this.params_filter = filter;
    this.params_page   = 1;
    this.loadData(this.params_filter, this.params_order, this.params_page);
  }

  loadData(paramsFilter, paramsOrder, paramsPage=1,) {
    PresenterReadUserHaveAsset(
      ReadPropsUserHaveAsset(
        "READ",
        this,
        this.onReadSuccess,
        this.onReadFailed,
        paramsFilter,
        paramsOrder,
        paramsPage
      )
    );
  }

  assetLoadMore() {
    PresenterReadUserAsset(
      ReadPropsUserAsset(
      	"next",
      	this,
      	this.onReadAssetSuccess,
      	this.onReadFailed,
      	null,
      	this.state.NextPage
      )
    )     
  }

  onReadSuccess(params, response) {
    let nextState = {};
    nextState = {
      RowElement    : this.generateRow(response.data.results),
      isLoading     : false,
      //Pagination
      table_loading : false,
      current       : response.data.current,
      count         : response.data.count,
      limit         : response.data.limit,
    }
    this.setState(nextState);
  }

  onReadFailed(params, response) {
    toast.error(response.data.detail)
    this.setState({
      table_loading: false
    })
  }

  onReadAssetSuccess(params, response){
    let nextState = {}
    if(params.action === 'read'){
      this.assetData = response.data.results
      nextState = {
        assetElement  : this.assetData,
        NextPage      : response.data.next,
        isLoading     : false,
      }
    }else{
      const asset = this.assetData.concat(response.data.results)
      nextState = {
        assetElement: asset,
        NextPage    : response.data.next
      }
      this.assetData = asset
    }
    this.setState(nextState);
  }

  renderRowElement(rowElement, isLoading, isSometingWrong, handlingSometingWentWrong, emptyStr = 'Data Empty') {
    if (isLoading) {
      return (
        <tr>
          <td className="table-loading-inside" colSpan="100%">Loading data . . .</td>
        </tr>
      )
    } 
    else if(isLoading === false && isSometingWrong === true){
        return(handlingSometingWentWrong('table'))
    }
    else if (!rowElement || rowElement.length === 0) {
      return (
        <tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;{emptyStr}</td></tr>
      )
    } 
    else if (rowElement.length > 0){
      return (rowElement)
    } 
    else {
      return(handlingSometingWentWrong('table'))
    }
  }
  /*  ============ LifeCyle ============ */
  componentDidMount() {
    this.loadData(this.params_filter, this.params_order, 1);
    this.timeoutWindow = window.setTimeout(function() {         
        if(this.state.isLoading){
            this.setState({
                isLoading       : false,
                loadingLoadMore : false, 
                isSometingWrong : true,
            })
        }
    }.bind(this), TimerConfig.SOMETHING_WRONG_TIME);
  }

  componentWillUnmount() {
    windowStop()
    window.clearTimeout(this.timeoutWindow)
  }

  render() {
    const {
      current, 
      count, 
      limit,
      activeToggle,
      table_loading, 
      RowElement, 
      isLoading,
      isSometingWrong
    } = this.state
    return (
      <div className="card-block">
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span className="icon-people" />&nbsp;Users
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default" title="Total user">
                <span className="icon-user" />&nbsp;{count} Users
              </div>
            </div>
          </div>
          <div className="col-sm-7 ">
            <FilterComponent onSearch={(e) => {this.dataWillFilter(e)}} self={this} target={'all'} FBColumn={this.tab} />
          </div>
        </div>
        <table className={classnames("table table-responsive table-hover table-outline mb-0 m-top-15 over-x", {"loading" : table_loading})}>
          <thead className="thead-default">
            <tr>
              <th onClick={()=>this.dataWillOrder('User__first_name')} className="pointer">
                User{activeToggle.activeField === 'User__first_name' && <i className={activeToggle.activeIcon}></i>}
              </th>
              <th onClick={()=>this.dataWillOrder('Asset_Count')} className="pointer text-center">
                Total Assets{activeToggle.activeField === 'Asset_Count' && <i className={activeToggle.activeIcon}></i>}                
              </th>
              <th onClick={()=>this.dataWillOrder('City__Name')} className="pointer text-center">
                City{activeToggle.activeField === 'City__Name' && <i className={activeToggle.activeIcon}></i>}                
              </th>
              <th>
                Registered
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowElement(
              RowElement,
              isLoading,
              isSometingWrong,
              HandlingSometingWentWrong
            )}
          </tbody>
        </table>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current  = {current}
              count    = {count}
              limit    = {limit}
              handle   = {this.handlePageClick.bind(this)}
              isLoading= {this.state.table_loading}
            />
          </div>
        </div>

        <ModalUserDetail 
          modalState        = {this.state.detailModal}
          closeModal        = {this.closeModalUserDetail}
          selectedData      = {this.state.selectedData}
          assetData         = {this.state.assetElement}
          assetLoadMore     = {this.assetLoadMore.bind(this)}
          renderRowElement  = {this.renderRowElement.bind(this)}
          nextPage          = {this.state.NextPage}
          history           = {this.props.history}
          UserReducer       = {this.props.UserReducer}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/user/userHaveAsset/helper/component/UserList.js